"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOfferResponseOffer = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const GetProductTariffsResponse_1 = tslib_1.__importDefault(require("../OfferWithEstimates/GetProductTariffsResponse"));
const BaseOfferFS_1 = require("../BaseOfferFS");
class GetOfferResponseOffer extends BaseOfferFS_1.BaseOfferFS {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({
        example: '4db7554c-e5cc-4c31-82b0-8bc7d134c0f7',
        description: 'The unique offer id that is generated by coupling the proposition with a profile',
    }),
    tslib_1.__metadata("design:type", String)
], GetOfferResponseOffer.prototype, "offerId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.DurationInYears)),
    (0, base_models_1.Docs)({
        example: base_models_1.DurationInYears.FLEX,
        description: 'Proposition duration.',
    }),
    tslib_1.__metadata("design:type", String)
], GetOfferResponseOffer.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => GetProductTariffsResponse_1.default),
    tslib_1.__metadata("design:type", GetProductTariffsResponse_1.default)
], GetOfferResponseOffer.prototype, "productTariffs", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({
        example: 'afa48d82-9f27-491b-87a4-8db8e2c393ee',
        description: 'Profile ID for the offer',
    }),
    tslib_1.__metadata("design:type", String)
], GetOfferResponseOffer.prototype, "profileId", void 0);
exports.GetOfferResponseOffer = GetOfferResponseOffer;
